
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables');
}

// The passkey opt-in is required: Supabase Auth's passkey API (beta since
// 2026-05-28) is gated behind this flag and the methods are absent without it.
// Supabase warns the API may change without notice during the beta, so treat a
// supabase-js upgrade as something that can break passkey sign-in specifically.
// Requires @supabase/supabase-js >= 2.105.0.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        experimental: { passkey: true },
    },
});
